import { useQuery } from "@tanstack/react-query";
import { supabase, invokeFunction } from "@/integrations/supabase/client";
import type { InventoryRegistrySourceRow } from "@/shared/types/inventorySource";

export function useInventoryLedgerSources(organisationId: string | undefined, enabled = true) {
  return useQuery({
    queryKey: ["inventory-ledger-sources", organisationId],
    enabled: Boolean(organisationId) && enabled,
    queryFn: async (): Promise<InventoryRegistrySourceRow[]> => {
      const { data, error } = await invokeFunction(supabase, "list-inventory-adjustable-sources-v1", {
        body: { organisation_id: organisationId },
      });
      if (error) throw new Error(error.message || "Failed to load inventory sources");
      if (!data?.success) throw new Error(data?.error || "Failed to load inventory sources");
      return (data.data || []) as InventoryRegistrySourceRow[];
    },
  });
}
